var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"action-buttons"},[_c('BButton',{staticClass:"action-button",attrs:{"variant":"primary"},on:{"click":function($event){return _vm.$emit('open-operations')}}},[_c('i',{staticClass:"fas fa-list"}),_vm._v(" "+_vm._s(_vm.$t('cockpit.operations'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }